export const FETCH_CONTENT_START = "FETCH_CONTENT_START"
export const FETCH_CONTENT_SUCCESS = "FETCH_CONTENT_SUCCESS"
export const FETCH_CONTENT_FAILED = "FETCH_CONTENT_FAILED"

export const FETCH_POSITION_START = "FETCH_POSITION_START"
export const FETCH_POSITION_SUCCESS = "FETCH_POSITION_SUCCESS"
export const FETCH_POSITION_FAILED = "FETCH_POSITION_FAILED"
